export default "/images/down-arr.svg?409afa7352963f86be124fa94410fd50";